export const useArray = () => {
  const shuffle = (array: any[]) => {
    let currentIndex = array.length,
      randomIndex

    while (currentIndex != 0) {
      randomIndex = Math.floor(Math.random() * currentIndex)
      currentIndex--
      ;[array[currentIndex], array[randomIndex]] = [array[randomIndex], array[currentIndex]]
    }
    return array
  }

  const pluck = <T>(array: T[], key: keyof T) => {
    return array.map((value) => value[key])
  }

  const pluckAndJoin = <T>(array: T[], key: keyof T, separator = ', ') => {
    return pluck(array, key).join(separator)
  }

  const isNotEmpty = <T>(array: T[]) => {
    return array.length > 0
  }

  const findByKey = <T>(array: T[], key: keyof T, value: any) => {
    return array.find((item) => item[key] === value)
  }

  return {
    findByKey,
    isNotEmpty,
    pluck,
    pluckAndJoin,
    shuffle
  }
}
